<template>
  <div class="loading" v-show="loading">
    <div class="ol">
      <div class="inner">
        <p>
          <span class="stp1">診</span><span class="stp2">断</span
          ><span class="stp3">完</span><span class="stp4">了</span>
        </p>
        <figure>
          <img
            src="../assets/img/common/result_chara.png"
            width=""
            height=""
            alt=""
          />
        </figure>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "loading",
  data: function () {
    return {
      loading: true,
    };
  },
  mounted: function () {
    setTimeout(
      function () {
        this.loading = false;
      }.bind(this),
      2000
    );
  },
};
</script>
<style>
/*pc*/
.loading {
  height: 100vh;
  position: relative;
}
.ol {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(255, 255, 255, 0.8);
  z-index: 1000;
}
.ol .inner {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
  color: #000;
  width: 80%;
  height: 70%;
  border: 8px solid #fff;
  background: url("../assets/img/common/bg_town.png") #fff666 no-repeat bottom
    center;
  outline: #b3af76 1px solid;
  animation: overlay2 1.25s ease-in-out;
}

.ol .inner p {
  font-family: "M PLUS Rounded 1c", "ヒラギノ角ゴ ProN",
    "Hiragino Kaku Gothic ProN", "游ゴシック体", "Yu Gothic", YuGothic,
    "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  line-height: 1.5em;
  font-weight: 600;
  font-size: 6rem;
  padding: 6vw 0;
  animation: overlay2 0.4s ease-in-out;
}

.ol .inner span {
  display: inline-block;
  margin: 0 0.5vw;
  animation: step 1s ease;
}

.ol .inner span.stp2 {
  animation-delay: 0.1s;
}

.ol .inner span.stp3 {
  animation-delay: 0.2s;
}

.ol .inner span.stp4 {
  animation-delay: 0.4s;
}

.ol figure {
  max-width: 504px;
  width: 60%;
  margin: 0 auto;
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  animation: scale 1s ease-in-out;
}

@media (max-width: 900px) {
  .ol .inner {
    height: 50%;
    background-size: 200%;
  }

  .ol figure {
    width: 70%;
  }
}
@media (max-width: 670px) {
  .ol figure {
    width: 80%;
  }

  .ol .inner p {
    font-size: 4rem;
    padding: 12vw 0;
  }
}

/*animation*/

@keyframes overlay2 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes scale {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  20% {
    opacity: 1;
    transform: scale(1.25);
  }
  30% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes step {
  0% {
    transform: translateY(-30px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
